/**
 * Created by razial on 14.01.2025.
 */

const MergeLocation = function (locationConfig, slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;

    this.locationConfig = locationConfig;
    this.locationId = locationConfig.locationId;

    this.families = Families.listExpeditionCodes(this.locationId); // todo move to location config

    const bundle = bundles[this.locationConfig.locationBundleId];
    if (!bundle) {
        throw new Error(`no bundle for location ${this.locationConfig.locationId} ${this.locationConfig.locationBundleId}`);
    }

    this.meta = bundle.meta;
};

MergeLocation.prototype = Object.create(cleverapps.EventEmitter.prototype);
MergeLocation.prototype.constructor = MergeLocation;

MergeLocation.prototype.isAllContentDone = function () {
    return Boolean(Map2dLocation.currentLocation && Map2dLocation.currentLocation.isAllExpeditionsPassed());
};

MergeLocation.prototype.reset = function () {
    this.slot.reset();

    if (this.locationConfig.withOwnGameLevel) {
        cleverapps.gameLevel.load();
    }

    if (this.locationConfig.withOwnGameLevel) {
        cleverapps.exp.load();
    }

    if (this.locationConfig.withOwnLives) {
        cleverapps.lives.load();
        cleverapps.lives.processRegenerateState();
    }
};

MergeLocation.prototype.setFirstSession = function () {
    this.firstSession = true;
};

MergeLocation.prototype.isCompleted = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.locationId);
    if (locationMeta.isExpired()) {
        return true;
    }

    if (this.locationConfig.achievementComplete && cleverapps.achievements.isAllGathered()) {
        return true;
    }

    if (QuestsWindow.IsAvailable() && Map2dLocation.currentLocation.quests.isAllDone) {
        return true;
    }

    return false;
};

MergeLocation.prototype.getStartTime = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.locationId);
    return locationMeta.getStartTime();
};

MergeLocation.prototype.getTimeLeft = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.locationId);
    return locationMeta.getTimeLeft();
};

MergeLocation.prototype.isGameMode = function () {
    return true;
};

MergeLocation.prototype.displayCompleted = function (f) {
    let expeditionReward;

    for (const id in MergeLocation.REWARDS) {
        if (!Map2d.currentMap.fogs.blocks[id]) {
            expeditionReward = MergeLocation.REWARDS[id];
        }
    }

    cleverapps.focusManager.compound(f, [
        function (f) {
            const quests = Map2dLocation.currentLocation.quests;

            if (!quests || !quests.hasAttention()) {
                f();
                return;
            }

            new QuestsWindow({ claimThresholds: true });
            cleverapps.focusManager.onceNoWindowsListener = f;
        },

        function (f) {
            const steps = [{
                text: "ExpeditionFinishWindow.text",
                person: {
                    role: "king",
                    emotion: "happy"
                }
            }];

            const dialogue = new Dialogue(steps, {
                showUp: true,
                autoClose: true
            });

            dialogue.on("afterClose", f);

            new DialogueView(dialogue);
        },

        function (f) {
            Map2dLocation.currentLocation.collectAllUnits(f);
        },

        function (f) {
            const actions = [];

            cleverapps.missionManager.listLocationMissions(this.locationId).forEach((mission) => {
                actions.push(mission.displayCompleted.bind(mission));
            });

            cleverapps.focusManager.compound(f, actions);
        }.bind(this),

        function (f) {
            cleverapps.meta.gotoMainLocation(f);
        },

        function (f) {
            if (expeditionReward) {
                new RewardWindow(expeditionReward, {
                    shareId: "bonus_world",
                    title: Messages.get("ExpeditionRewardWindow.title"),
                    text: Messages.get("ExpeditionRewardWindow.description"),
                    event: cleverapps.EVENTS.EARN.OTHER
                });
            }

            cleverapps.eventBus.trigger("taskEvent", "FINISH_EXPEDITION");

            cleverapps.meta.finishLocation(this.locationId);

            if (expeditionReward) {
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }.bind(this),

        function (f) {
            if (typeof QuestsWindow !== "undefined" && QuestsWindow.IsAvailable()) {
                f();
                return;
            }

            const landmarks = Map2dLocation.currentLocation && Map2dLocation.currentLocation.landmarks;
            const configs = cleverapps.achievements ? AchievementsConfig.listByExpedition(this.locationId) : [];
            const achievement = configs.find((config) => cleverapps.achievements && cleverapps.achievements.isGathered(config.id) && config.targetExpedition === "main");

            const deployed = landmarks && landmarks.listDeployed();
            if (landmarks && achievement && ((deployed.length > 0 && deployed[0].stage !== achievement.stage) || deployed.length === 0)) {
                const landmarkUnit = landmarks.construct(achievement);
                cleverapps.focusManager.compound(f, landmarks.replaceActions(landmarkUnit));
            } else if (!landmarks && achievement && typeof AchievementsWindow !== "undefined") {
                new AchievementsWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            } else {
                f();
            }
        }.bind(this)
    ]);
};

MergeLocation.prototype.resetPush = function () {
    const locationMeta = cleverapps.meta.getLocationMeta(this.locationId);

    if (locationMeta.getTimeLeft() >= MergeLocation.ATTENTION_TIMEOUT) {
        PushHelper.sendPush(PUSHES.EXPEDITION, MergeLocation.ATTENTION_TIMEOUT);
    }
};

MergeLocation.prototype.compareWithReferenceLocations = function () {
    this.expeditionCompareWithReferenceLocations();
};

MergeLocation.prototype.expeditionCompareWithReferenceLocations = function () {
    const currentMap = bundles[this.locationConfig.locationBundleId].jsons.map_json.resolve().getJson();
    const currentField = cleverapps.clone(currentMap.field, true);

    const referenceMap = bundles[Map2dLocation.GetLocationReferenceBundleId(this.locationId)].jsons.map_json.resolve().getJson();
    const referenceField = cleverapps.clone(referenceMap.field, true);

    const fogsUnits = {};

    const currentFogs = {};
    const referenceFogs = {};

    for (const fog of Object.keys(currentMap.regions)) {
        for (const position of currentMap.regions[fog].positions) {
            currentFogs[`${position.x}_${position.y}`] = fog;
        }
    }

    for (const fog of Object.keys(referenceMap.regions)) {
        for (const position of referenceMap.regions[fog].positions) {
            referenceFogs[`${position.x}_${position.y}`] = fog;
        }
    }

    currentField.forEach((unit) => {
        const key = Unit.GetKey(unit);
        const fog = currentFogs[`${unit.x}_${unit.y}`];
        if (!fogsUnits[fog]) {
            fogsUnits[fog] = {};
        }
        if (!fogsUnits[fog][key]) {
            fogsUnits[fog][key] = {
                current: 0,
                reference: 0
            };
        }
        fogsUnits[fog][key].current += 1;
    });

    referenceField.forEach((unit) => {
        const key = Unit.GetKey(unit);
        const fog = referenceFogs[`${unit.x}_${unit.y}`];
        if (!fogsUnits[fog]) {
            fogsUnits[fog] = {};
        }
        if (!fogsUnits[fog][key]) {
            fogsUnits[fog][key] = {
                current: 0,
                reference: 0
            };
        }
        fogsUnits[fog][key].reference += 1;
    });

    const errors = [];

    for (const fog in fogsUnits) {
        for (const unitKey in fogsUnits[fog]) {
            const data = fogsUnits[fog][unitKey];

            if (data.current !== data.reference) {
                errors.push(`Error in ${fog} - unit ${unitKey} mismatch: reference ${data.reference}, current ${data.current}`);
            }
        }
    }

    if (errors.length) {
        cleverapps.throwAsync(`Found the following errors in map:\n ${errors.join("\n")}`);
    } else {
        console.log("No errors found - units in fogs math the reference");
    }
};

MergeLocation.GetMainScene = function () {
    return cleverapps.config.type === "merge2" ? bundles.main.jsons.merge2scene_prefab_json : bundles.main.jsons.map2dlocationscene_prefab_json;
};

MergeLocation.OnLocationStart = function (locationMeta) {
    UnitsLibraryHelper.resetMainInstanceFamilies(locationMeta.locationId);

    if (typeof Achievements !== "undefined") {
        Achievements.clearForce(locationMeta.locationId);
    }

    cleverapps.travelBook && cleverapps.travelBook.startNewExpedition(locationMeta);
};

MergeLocation.OnLocationFinish = function () {
    cleverapps.travelBook && cleverapps.travelBook.updatePages();
};

MergeLocation.LogActiveTime = function () {
    const location = cleverapps.meta.getSelectedLocation();
    if (!location) {
        return;
    }

    if (location.locationConfig.isMain) {
        return;
    }

    if (location.firstSession) {
        cleverapps.playSession.logAvg(cleverapps.EVENTS.LOCATION.FIRST_TIME, {
            value: 1,
            location: location.locationId,
            key: `${cleverapps.EVENTS.LOCATION.FIRST_TIME}_${location.locationId}`
        });
    }

    cleverapps.playSession.logAvg(cleverapps.EVENTS.LOCATION.PLAYED_TIME, {
        value: 1,
        location: location.locationId,
        key: `${cleverapps.EVENTS.LOCATION.PLAYED_TIME}_${location.locationId}`
    });
};

PlaySession.ActiveTimeListeners.push(MergeLocation.LogActiveTime);

MergeLocation.ATTENTION_TIMEOUT = cleverapps.parseInterval("2 days");

if (cleverapps.config.debugMode) {
    MergeLocation.ATTENTION_TIMEOUT = cleverapps.parseInterval("10 minutes");
}

MergeLocation.REWARDS = {
    fog1: {
        soft: 10
    },
    fog6: {
        soft: 10,
        lives: 10
    },
    fog16: {
        soft: 20,
        lives: 20
    },
    fog26: {
        soft: 30,
        lives: 30
    },
    fog36: {
        soft: 50,
        lives: 50
    }
};
